import { DATA_MAPPING_SELECTION_OPTIONS } from 'app/modules/dataMapping/constants';
import {
  DataMappingObject,
  DataMappingSchema,
  PrimaryObject,
  SecondaryObject,
} from 'app/modules/dataMapping/types';

export type CheckImageSide = 'front' | 'back';

interface CheckImageUpdateConfig {
  label: string;
  mediaType: string;
  objectName: string;
  sourceField: string;
}

export const CHECK_IMAGE_UPDATE_CONFIGS: Record<
  CheckImageSide,
  CheckImageUpdateConfig
> = {
  front: {
    label: 'Front of check image',
    mediaType: 'IMAGE_CHECK_FRONT',
    objectName: '__enrichment_check_image_front__',
    sourceField: 'front_image_s3_path',
  },
  back: {
    label: 'Back of check image',
    mediaType: 'IMAGE_CHECK_BACK',
    objectName: '__enrichment_check_image_back__',
    sourceField: 'back_image_s3_path',
  },
};

export const getCheckImageAttachmentObject = (
  side: CheckImageSide,
  objectToAttach: PrimaryObject,
): DataMappingObject<SecondaryObject.ATTACHMENT> => {
  const config = CHECK_IMAGE_UPDATE_CONFIGS[side];
  return {
    name: config.objectName,
    type: SecondaryObject.ATTACHMENT,
    object_to_attach: [objectToAttach],
    typed_annotations: [
      {
        destination: 'file_s3_path',
        value: {
          selection: {
            key: config.sourceField,
            type: DATA_MAPPING_SELECTION_OPTIONS.STREAM_VALUE,
          },
          transformations: [],
        },
      },
      {
        // dumbledore re-encodes every X9 check image to JPEG before upload
        // (see x9/upload_bytes_to_s3.py), so the MIME is always image/jpeg.
        destination: 'mime_type',
        value: {
          selection: {
            type: DATA_MAPPING_SELECTION_OPTIONS.HARD_CODED_VALUE,
            value: 'image/jpeg',
          },
          transformations: [],
        },
      },
      {
        destination: 'media_type',
        value: {
          selection: {
            type: DATA_MAPPING_SELECTION_OPTIONS.HARD_CODED_VALUE,
            value: config.mediaType,
          },
          transformations: [],
        },
      },
    ],
    custom_data_annotations: [],
  };
};

export const hasCheckImageUpdate = (
  config: DataMappingSchema | null | undefined,
  side: CheckImageSide,
): boolean => {
  return Boolean(config?.objects[CHECK_IMAGE_UPDATE_CONFIGS[side].objectName]);
};
